


export  function isFormItemsClassificationForViewAndShowAll(viewCountClassification, showAllViewClassification): boolean {
   return viewCountClassification === 'formItems' && showAllViewClassification === 'formItems';
 }

export  function isFormItemsViewAndDataShowAll(viewCountClassification, showAllViewClassification): boolean {
  return viewCountClassification === 'formItems' && showAllViewClassification === 'data';
}

export function isDerivedClassification(classification, countType) : boolean {
  if (countType === 'viewCount' && classification['viewCount']) {
   return classification['viewCount'] === 'derived';
  }
  if (countType === 'showAllCount' && classification['showAllCount']) {
   return classification['showAllCount'] === 'derived';
  }

 }


export  function isFormItemsWithDataShowAll(showAllViewClassification): boolean {
  return showAllViewClassification === 'formItemsWithData' ;
}

